import Swiper from 'swiper';
import { register } from 'swiper/element/bundle';
import 'swiper/swiper-bundle.css';
register();

function pauseVideo(iframe) {
  iframe.contentWindow.postMessage(
    '{"event":"command","func":"pauseVideo","args":""}',
    '*',
  );
}
const swiper = new Swiper('.swiper-home', {
  slidesPerView: 1,
  loop: true,
  effect: 'fade',
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  },
  // pagination: {
  //   el: '.swiper-home-pagination',
  //   clickable: true,
  // },
  navigation: {
    nextEl: '.swiper-home-button-next',
    prevEl: '.swiper-home-button-prev',
  },
  // on: {
  //   slideChangeTransitionStart: function () {
  //     let videos = document.querySelectorAll('.video-banner');
  //     videos.forEach((video) => {
  //       pauseVideo(video);
  //     });
  //   },
  // },
});

const swiper2 = new Swiper('.swiper-partner', {
  loop: true,
  autoplay: {
    delay: 8000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-partner-button-next',
    prevEl: '.swiper-partner-button-prev',
  },
  slidesPerView: 2,
  spaceBetween: 20,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  },
});

const videoThumbs = new Swiper('.slider-video-thumbs', {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: false,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});
const videoTop = new Swiper('.slider-video-top', {
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-slider-video-button-next',
    prevEl: '.swiper-slider-video-button-prev',
  },
  thumbs: {
    swiper: videoThumbs,
  },
});

// LANDING PAGE
const swiperLandingPage = new Swiper('.swiper-landing-page', {
  slidesPerView: 1,
  loop: true,
  effect: 'fade',
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-landing-page-button-next',
    prevEl: '.swiper-landing-page-button-prev',
  },
});
const galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 20,
  slidesPerView: 'auto',
  freeMode: false,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
  },
});
const galleryTop = new Swiper('.gallery-top', {
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-landing-page-thumbs-button-next',
    prevEl: '.swiper-landing-page-thumbs-button-prev',
  },
  thumbs: {
    swiper: galleryThumbs,
  },
});
const videosLandingPage = new Swiper('.slider-video-landing-page', {
  slidesPerView: 1,
  navigation: {
    nextEl: '.slider-video-landing-page-button-next',
    prevEl: '.slider-video-landing-page-button-prev',
  },
});
